import React from 'react';

import {Helmet} from 'views/module';

import MyDayScene from 'views/scenes/tasks/my_day/MyDay';

const MyDay = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: My Day</title>
      </Helmet>
      <MyDayScene />
    </>
  );
};

export default MyDay;
